import { render, staticRenderFns } from "./search-result.vue?vue&type=template&id=c503b378&scoped=true&"
import script from "./search-result.vue?vue&type=script&lang=js&"
export * from "./search-result.vue?vue&type=script&lang=js&"
import style0 from "./search-result.vue?vue&type=style&index=0&id=c503b378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c503b378",
  null
  
)

export default component.exports